import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { generateSuggestedLocations } from 'tripPlanner/api'
import * as SuggestedLocationKeys from '../reactQueryKeys/suggestedLocations'

export interface SuggestedLocationItem {
  name: string,
  imageId: string,
  url: string,
  destinationId: string | undefined,
  country: string | undefined,
}

export const useSuggestedLocations = (
  { locations }: {
    locations: Array<string>
  },
): UseQueryResult<Array<SuggestedLocationItem> | undefined> => {
  const hasValidParams = locations && locations.length > 0
  return useQuery(
    SuggestedLocationKeys.suggestedLocations(locations),
    async() => {
      if (!hasValidParams) {
        return undefined
      }
      const result = await generateSuggestedLocations({ locations })
      return result
    },
    {
      enabled: hasValidParams,
    },
  )
}
